import { FC } from 'react';
import styles from './index.module.less';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';

/**
 * 拓店任务-详情-基本信息
 * @Description 拓店任务：加盟（益禾堂、非益禾堂）
 */
const BasicInfo:FC<{
  detail: any;
  aprDetail: any;
  franchiseeAlias: string;
  expansionTaskAlias: string;
  hideFranchiseeUniqueId?: boolean;
}> = ({
  detail,
  aprDetail,
  franchiseeAlias,
  expansionTaskAlias,
  hideFranchiseeUniqueId = false,
}) => {

  const infos: any[] = [
    { label: `${expansionTaskAlias || '任务'}类型`, value: detail?.taskTypeName, maxWidth: '106px' },
    { label: '开发人员', value: aprDetail?.manager || detail?.manager || detail?.developManager, maxWidth: '106px' },
    { label: '期望落位日期', value: detail?.expectDropInDate, maxWidth: '85px' },
    { label: `${franchiseeAlias}姓名`, value: detail?.franchiseeDetail?.name, maxWidth: '96px' },
    !hideFranchiseeUniqueId ? { label: detail?.franchiseeDetail?.uniqueName || `${franchiseeAlias}唯一标识`, value: detail?.franchiseeDetail?.uniqueId, maxWidth: '143px' } : null,
  ].filter(Boolean);

  return <div className='pb-4'>
    <V2DetailGroup moduleType='easy' className={styles.basicInfo}>
      {
        infos.map((item, index) => <div
          style={{
            maxWidth: item?.maxWidth,
            width: item?.maxWidth,
          }}
          className={styles.card}
          key={index}>
          { item?.node || <V2DetailItem label={item?.label} value={item?.value} />}
        </div>
        )
      }
    </V2DetailGroup>

  </div>;
};
export default BasicInfo;
